import { z } from 'zod';

import { TypeSectionTemplate } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const SectionTemplateEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    accessType: z.enum(['Authenticated Only', 'CSR Only', 'Public']),
    theme: z.enum(['BA Polymers', 'Entec', 'Ravago One', 'Resinex', 'Ultrapolymers']),
    category: z.string(),
    pageContent: z.array(z.any()).optional().nullable(),
    translations: z.record(z.string(), z.any()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateSectionTemplateEntry(data: TypeSectionTemplate) {
  return SectionTemplateEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateSectionTemplateEntries(data: TypeSectionTemplate[]) {
  return z.array(SectionTemplateEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterSectionTemplateEntries(data: TypeSectionTemplate[]) {
  if (!data) return [];

  return data.reduce((acc: TypeSectionTemplate[], entry) => {
    const validationResult = validateSectionTemplateEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeSectionTemplate);
    } else {
      console.warn(
        `Validation failed for section template entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
